const toggle = document.querySelector('.menu-toggle');
const mobileNav = document.querySelector('.mobile-nav');
toggle?.addEventListener('click', () => {
  const open = toggle.getAttribute('aria-expanded') !== 'true';
  toggle.setAttribute('aria-expanded', String(open));
  toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
  mobileNav.hidden = !open;
});
const dropdownButtons = [...document.querySelectorAll('.nav-dropdown__button')];
for (const button of dropdownButtons) {
  button.addEventListener('click', () => {
    const expanded = button.getAttribute('aria-expanded') !== 'true';
    for (const other of dropdownButtons) {
      const isOpen = other === button && expanded;
      other.setAttribute('aria-expanded', String(isOpen));
      other.parentElement.classList.toggle('is-open', isOpen);
    }
  });
}
function closeMarketingMenu(restoreFocus = false) {
  if (!toggle || !mobileNav || toggle.getAttribute('aria-expanded') !== 'true') return false;
  toggle.setAttribute('aria-expanded', 'false');
  toggle.setAttribute('aria-label', 'Open menu');
  mobileNav.hidden = true;
  if (restoreFocus) toggle.focus();
  return true;
}
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const closedMenu = closeMarketingMenu(true);
  let closedDropdown = null;
  for (const button of dropdownButtons) {
    if (button.getAttribute('aria-expanded') !== 'true') continue;
    button.setAttribute('aria-expanded', 'false');
    button.parentElement.classList.remove('is-open');
    closedDropdown ??= button;
  }
  if (closedDropdown && !closedMenu) closedDropdown.focus();
  if (closedMenu || closedDropdown) event.preventDefault();
});
window.matchMedia('(min-width:1460px)').addEventListener('change', (event) => {
  if (event.matches) closeMarketingMenu();
});
document.addEventListener('click', (event) => {
  for (const button of dropdownButtons) {
    if (!button.parentElement.contains(event.target)) {
      button.parentElement.classList.remove('is-open');
      button.setAttribute('aria-expanded', 'false');
    }
  }
});

// Shopify handles delivery and confirmation for the native contact form.
// This enhancement only prepares the owner's direct-contact alternatives.
const form = document.getElementById('rental-form');
if (form) {
  const params = new URLSearchParams(window.location.search);
  const format = form.elements.namedItem('contact[Rental format]');
  const selected = params.get('package');
  if (selected && format && [...format.options].some((option) => option.value === selected)) {
    format.value = selected;
  }
  const emailDraft = document.getElementById('email-draft');
  const whatsappDraft = document.getElementById('whatsapp-draft');
  const fields = [
    ['Name', 'contact[name]'],
    ['Email', 'contact[email]'],
    ['Phone', 'contact[phone]'],
    ['Company', 'contact[Company]'],
    ['Rental format', 'contact[Rental format]'],
    ['Event date', 'contact[Event date]'],
    ['Location', 'contact[Event location]'],
    ['Event type', 'contact[Event type]'],
    ['Guests', 'contact[Estimated guests]'],
    ['Duration', 'contact[Rental duration]'],
    ['Preferred contact', 'contact[Preferred contact method]'],
    ['Notes', 'contact[body]'],
  ];
  const preferences = ['Brand integration', 'Multi-screen setup', 'Motion simulator', 'Competition format'];
  function updateDraft() {
    const data = new FormData(form);
    const lines = ['Simuluxor rental inquiry', ''];
    for (const [label, key] of fields) lines.push(`${label}: ${data.get(key) || 'Not provided'}`);
    lines.push(`Preferences: ${preferences.filter((item) => data.has(`contact[${item}]`)).join(', ') || 'Not specified'}`);
    const message = lines.join('\n');
    emailDraft.href = `mailto:robert@simuluxor.com?subject=${encodeURIComponent('Simuluxor rental inquiry')}&body=${encodeURIComponent(message)}`;
    whatsappDraft.href = `https://wa.me/14164528880?text=${encodeURIComponent(message)}`;
  }
  form.addEventListener('input', updateDraft);
  form.addEventListener('change', updateDraft);
  updateDraft();
}

// The hero keeps its still frame for reduced-motion and data-saving visitors.
const dataSaverOn = navigator.connection?.saveData === true;
const heroVideo = document.querySelector('[data-hero-video]');
if (heroVideo) {
  const heroSource = heroVideo.querySelector('source[data-src]');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let heroInView = true;

  function playHeroVideo() {
    if (reducedMotion.matches || dataSaverOn || document.hidden) {
      heroVideo.pause();
      return;
    }
    if (heroVideo.dataset.loaded !== 'true') {
      heroSource.src = window.matchMedia('(max-width:650px)').matches ? heroSource.dataset.mobileSrc : heroSource.dataset.src;
      heroVideo.dataset.loaded = 'true';
      heroVideo.load();
    }
    heroVideo.play().catch(() => {});
  }

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(([entry]) => {
      heroInView = entry.isIntersecting;
      if (heroInView) playHeroVideo();
      else heroVideo.pause();
    }, { threshold: 0.05 });
    observer.observe(heroVideo.closest('.hero'));
  } else {
    playHeroVideo();
  }

  reducedMotion.addEventListener?.('change', () => {
    if (reducedMotion.matches) heroVideo.pause();
    else if (heroInView) playHeroVideo();
  });
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) heroVideo.pause();
    else if (heroInView) playHeroVideo();
  });
}

// The second homepage video is decorative; defer its download and playback until needed.
const nightVideo = document.querySelector('[data-night-video]');
if (nightVideo) {
  const nightSection = nightVideo.closest('.intro-section--night');
  const nightSource = nightVideo.querySelector('source[data-src]');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function playNightVideo() {
    if (reducedMotion.matches || dataSaverOn || document.hidden) return;
    if (nightVideo.dataset.loaded !== 'true') {
      nightSource.src = nightSource.dataset.src;
      nightVideo.dataset.loaded = 'true';
      nightVideo.load();
    }
    nightVideo.play().catch(() => {});
  }

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) playNightVideo();
      else nightVideo.pause();
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
    observer.observe(nightSection);
  } else if (!reducedMotion.matches && !dataSaverOn) {
    playNightVideo();
  }

  reducedMotion.addEventListener?.('change', () => {
    if (reducedMotion.matches) {
      nightVideo.pause();
      return;
    }
    const sectionBounds = nightSection.getBoundingClientRect();
    if (sectionBounds.bottom > 0 && sectionBounds.top < window.innerHeight) playNightVideo();
  });
}

// Shopify's native page paths retain the selected marketing navigation state.
for (const link of document.querySelectorAll('.site-header a.nav-link')) {
  if (link.getAttribute('href') === location.pathname) {
    link.classList.add('is-active');
    link.setAttribute('aria-current', 'page');
  }
}
if (location.pathname.startsWith('/pages/mobile-race-studio') || location.pathname.startsWith('/pages/two-simulators') || location.pathname.startsWith('/pages/single-simulator') || location.pathname === '/pages/race-components' || location.pathname === '/pages/pay-to-race-events') {
  document.querySelector('.desktop-nav .nav-dropdown__button')?.classList.add('is-active');
}

// Gallery playback is a user-initiated action: never auto-download or mute these films.
for (const player of document.querySelectorAll('[data-gallery-player]')) {
  const video = player.querySelector('video');
  const button = player.querySelector('[data-gallery-play]');
  const label = button?.querySelector('.archive-film__play-label');
  const directLink = player.querySelector('.archive-film__open');
  const status = player.querySelector('.archive-film__status');
  if (!video || !button || !label || !directLink || !status) continue;

  const title = video.getAttribute('aria-label') || 'this film';
  let attempt = 0;
  let loadingTimer;
  let playbackStarted = false;
  let failedAttempt = -1;
  let restoreFocus = false;
  button.hidden = false; // Without JavaScript, the native video controls remain usable.

  function showFailure(message, id = attempt, force = false) {
    if (id !== attempt || failedAttempt === id || playbackStarted && !force) return;
    failedAttempt = id;
    clearTimeout(loadingTimer);
    video.pause();
    button.disabled = false;
    button.hidden = false;
    button.setAttribute('aria-label', `Retry ${title} video`);
    label.textContent = 'Retry video';
    directLink.hidden = false;
    status.textContent = message;
    status.hidden = false;
    if (restoreFocus) button.focus({ preventScroll: true });
    restoreFocus = false;
  }

  button.addEventListener('click', () => {
    const retry = failedAttempt === attempt || Boolean(video.error);
    const id = ++attempt;
    clearTimeout(loadingTimer);
    playbackStarted = false;
    restoreFocus = document.activeElement === button;
    button.disabled = true;
    label.textContent = 'Loading film…';
    status.hidden = true;
    directLink.hidden = true;
    if (retry) video.load();
    if (video.ended) video.currentTime = 0;
    loadingTimer = setTimeout(() => {
      if (!playbackStarted) showFailure('This film is taking longer than expected. Retry or open the file directly.', id);
    }, 12000);
    // Keep play() in this trusted click call stack so mobile browsers permit audio.
    const playback = video.play();
    playback?.catch(() => showFailure('This film could not start here. Retry or open the file directly.', id));
  });

  video.addEventListener('gallery:interrupt', () => {
    if (playbackStarted || !button.disabled) return;
    // Invalidate a pending play() rejection when the visitor switches films.
    attempt++;
    clearTimeout(loadingTimer);
    button.disabled = false;
    button.hidden = false;
    button.setAttribute('aria-label', `Play ${title} video`);
    label.textContent = 'Play film';
    directLink.hidden = true;
    status.hidden = true;
    restoreFocus = false;
  });
  video.addEventListener('play', () => {
    for (const other of document.querySelectorAll('[data-gallery-player] video')) {
      if (other === video || other.paused) continue;
      other.dispatchEvent(new Event('gallery:interrupt'));
      other.pause();
    }
  });

  video.addEventListener('playing', () => {
    playbackStarted = true;
    clearTimeout(loadingTimer);
    button.hidden = true;
    if (restoreFocus) video.focus({ preventScroll: true });
    restoreFocus = false;
    button.disabled = false;
    directLink.hidden = true;
    status.hidden = true;
  });
  video.addEventListener('error', () => {
    showFailure('This film could not load here. Retry or open the file directly.', attempt, true);
  });
  video.addEventListener('ended', () => {
    button.hidden = false;
    button.setAttribute('aria-label', `Replay ${title} video`);
    label.textContent = 'Play again';
  });
}
